export default __webpack_public_path__ + "static/media/JackBaiResume.50bde6b3.pdf";